<template lang="pug">
  .complete.box
    h1.has-text-weight-bold THANK YOU FOR YOUR REQUEST
    p.has-text-weight-normal Your request has been sent, someone will be in contact shortly.

</template>

<script>
  export default {
    methods: {
    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";
  @import "../styles/variables";

  .complete {
    margin: 3rem 3rem 0 3rem;
    text-align: left;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100%;
    justify-content: left;
    @include until($desktop) {
      flex-direction: column;
    }

    h1 {
      font-size: 2rem;
      line-height: 1.125;
      margin-bottom: 2rem;
    }

    p {
      margin-bottom: 2rem;
    }
  }
</style>
